// @flow
import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import {
  activateToken,
  deactivateToken,
  getTokenList,
  deleteToken,
  addNewToken,
} from 'actions/app';
import ErrorsNotification from 'components/others/ErrorNotification';
import './TokenContainer.scss';
import TokenGenerator from './TokenGenerator';
import TokenModal from './TokenModal';

type Props = {
  getTokenList: Function,
  userTokens: Object,
  deactivateToken: Function,
  activateToken: Function,
  deleteToken: Function,
  addNewToken: Function,
  tokenCreationError: boolean,
  updateTokenSuccess: boolean,
  newToken: String,
}

export class TokenContainer extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      status: [],
      tokens: null,
      maxTokensCreated: false,
      newTokenCreated: false,
    };
  }

  componentDidMount() {
    this.props.getTokenList();
  }

  componentWillUpdate(nextProps: Props) {
    const tokenListChanged: boolean = this.props.userTokens !== nextProps.userTokens;
    const maxTokensCreated: boolean = (this.props.tokenCreationError !== nextProps.tokenCreationError)
        && nextProps.tokenCreationError;

    const updateTokenSuccessful: boolean = this.props.updateTokenSuccess !== nextProps.updateTokenSuccess
        && nextProps.updateTokenSuccess;

    const newTokenCreated: boolean = !!nextProps.newToken && !this.state.newTokenCreated;

    if (tokenListChanged) {
      this.setState({
        tokens: nextProps.userTokens,
      });
    }

    if (newTokenCreated) {
      this.setState({
        newTokenCreated: true,
      });
    }
    if (maxTokensCreated) {
      this.setState({
        maxTokensCreated: true,
      });
    }
    if (updateTokenSuccessful) {
      this.props.getTokenList();
    }
  }

  handleCloseModal() {
    this.setState({
      newTokenCreated: false,
    });
  }

  render() {
    const tokens = this.state.tokens;
    let generatedTokens = [];
    if (tokens) {
      generatedTokens = tokens.map(token => (
        <TokenGenerator
          key={token.tokenId}
          jwtTokenID={token.tokenId}
          tokenDeleteRequest={(jwt) => {
            this.props.deleteToken(jwt);
          }}
          active={token.status}
          expiry={token.expiredAt}
          tokenActivateRequest={(jwt) => {
            this.props.activateToken(jwt);
          }}
          tokenDeactivateRequest={(jwt) => {
            this.props.deactivateToken(jwt);
          }}
        />));
    }
    const alert = [{ message: 'Token Creation Limit Reached.' }];
    return (
      <DocumentTitle title="Marionette">
        <div className="token-page has-text-centered">
          <div className="token-control">
            {this.state.maxTokensCreated &&
              <ErrorsNotification
                errors={alert}
                dismissible
                onClose={() => {
                  this.setState({
                    maxTokensCreated: false,
                  });
                  this.props.getTokenList();
                }}
              />
            }
            <button
              className="button is-primary"
              title="Create New Token"
              aria-label="Create New Token"
              onClick={() => {
                this.props.addNewToken();
              }}
            >
              Create New Token
              <span className="icon" aria-hidden="true">
                <i className="fa fa-plus" />
              </span>
            </button>
          </div>
          {generatedTokens}
          {this.state.newTokenCreated &&
            <TokenModal
              jwtToken={this.props.newToken}
              showModal="true"
              handleClose={() => this.handleCloseModal()}
            />
          }
        </div>
      </DocumentTitle>
    );
  }
}

function mapStateToProps(state) {
  return {
    userTokens: state.app.tokenList || [],
    tokenCreationError: state.app.tokenCreationError || false,
    updateTokenSuccess: state.app.updateTokenSuccess || false,
    newToken: state.app.newToken || null,
  };
}

export default connect(
    mapStateToProps, {
      getTokenList,
      activateToken,
      deactivateToken,
      deleteToken,
      addNewToken,
    }
)(TokenContainer);



/** WEBPACK FOOTER **
 ** ./src/js/views/token_management/TokenContainer.js
 **/